import React from 'react';
import styles from './IconButton.module.scss';
import classNames from 'classnames';

interface IProps {
  children: React.ReactNode,
  disabled?: boolean
  labelText: string,
  [index: string]: unknown
}

const IconButton: React.FC<IProps> = ({ children, labelText, disabled = false, ...props }) => {
  const p = { ...props };
  if (disabled) {
    p.onClick = undefined;
  }

  return (
    <button {...p} title={labelText} aria-label={labelText} className={classNames(styles.buttonWrapper, disabled ? styles.disabled : '')}>
      {children}
    </button>);
};

export default IconButton;
